"use strict";

exports.__esModule = true;
exports.AlertTrendChart = void 0;
var _react = _interopRequireDefault(require("react"));
var _Time = require("../../../Time");
var _TimeSeriesLineChart = require("../../../Recharts/Charts/TimeSeriesLineChart");
var _styles = require("../styles");
var _Core = require("../../../Core");
var _chartUtils = require("../utils/chartUtils");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var AlertTrendChart = exports.AlertTrendChart = function AlertTrendChart(_ref) {
  var data = _ref.data,
    period = _ref.period,
    title = _ref.title,
    width = _ref.width;
  var time = _react["default"].useContext(_Time.TimeContext);
  var _React$useContext = _react["default"].useContext(_Core.TranslatorContext),
    translate = _React$useContext.translate;
  var ref = _react["default"].useRef(null);
  var _period$split = period.split("/"),
    start = _period$split[0],
    end = _period$split[1];
  var prepareData = function prepareData() {
    var createdAlertsNum = (0, _chartUtils.sumAlertCounts)(data, function (item) {
      return item.day;
    }).map(function (item) {
      return {
        key: new Date(item.key).getTime(),
        value: item.count
      };
    });
    return [{
      data: createdAlertsNum
    }];
  };
  var formattedData = prepareData();
  var selectedInterval = (0, _chartUtils.getSelectedInterval)({
    start: start,
    end: end
  });
  var chartProps = (0, _chartUtils.getChartProps)({
    start: start,
    end: end
  }, {
    selectedInterval: selectedInterval,
    timezone: time.timezone,
    hideAxis: false
  }, {
    enableYDomain: true,
    minYValue: Math.min.apply(Math, formattedData.map(function (item) {
      return item.value;
    })),
    maxYValue: Math.max.apply(Math, formattedData.map(function (item) {
      return item.value;
    })),
    hideAxis: false
  }, {
    yValueName: translate("AlertsAnalysisScreen.AlertTrendChart.tooltipValue", "Created Alerts")
  });
  return /*#__PURE__*/_react["default"].createElement(_styles.ChartWrapper, {
    ref: ref,
    "data-testid": "AlertsAnalysis.AlertTrendChart.container"
  }, /*#__PURE__*/_react["default"].createElement(_styles.ChartTitle, null, title), /*#__PURE__*/_react["default"].createElement(_TimeSeriesLineChart.TimeSeriesLineChart, {
    width: width,
    height: 400,
    data: formattedData,
    tooltipProps: chartProps.tooltipProps,
    xAxisProps: chartProps.xAxisProps,
    yAxisProps: chartProps.yAxisProps,
    showLegend: false,
    chartCurve: "linear"
  }));
};